import PropTypes from 'prop-types';
import { useContext } from 'react';
import { useIsGlobetrotter } from '@bwoty-web/ui-kit/hooks';
import { Message, PromotionBadge } from '@bwoty-web/ui-kit';

import GlobalContext from '../../context/globalContext';
import CruisePackageInfoHotel from './CruisePackageInfoHotel';
import CruisePackageInfoFlight from './CruisePackageInfoFlight';

import './cruisePackageInfo.scss';

const CruisePackageInfo = ({ accommodation, duration, transport, promoLabel }) => {
  const isGlobetrotter = useIsGlobetrotter();
  const { labels } = useContext(GlobalContext);

  const flights = [transport?.outBoundFlights[0], transport?.homeBoundFlights[0]];
  const { numberOfHotelNights, hotels } = accommodation;

  return (
    <div className="iw-cruise-package-info uikit-box">
      <div className="iw-cruise-package-info__header-container">
        <div className="iw-cruise-package-info__header">
          <div className="iw-cruise-package-info__heading">{labels?.packageInfoHeading}</div>
          {!isGlobetrotter && <div className="iw-cruise-package-info__duration">{duration}</div>}
        </div>
        {promoLabel && (
          <PromotionBadge
            promotion={promoLabel?.text}
            urgency={promoLabel?.urgency}
            type={promoLabel?.promotionType}
          />
        )}
      </div>
      <div className="iw-cruise-package-info__mid-container">
        <div className="iw-cruise-package-info__flights">
          <p className="iw-cruise-package-info__flights-heading">{labels?.packageInfoFlightHeading}</p>
          <div>
            {flights?.map((flight, i) => {
              return (
                <CruisePackageInfoFlight
                  key={flight?.bookingEngineKey}
                  flight={flight}
                  index={i}
                />
              );
            })}
          </div>
        </div>
        {numberOfHotelNights > 0 && (
          <div className="iw-cruise-package-info__hotels">
            <p className="iw-cruise-package-info__hotels-heading">
              {numberOfHotelNights === 1
                ? labels?.packageInfoHotelHeading
                : labels?.packageInfoHotelHeadingPlural?.replace('{numberOfNights}', numberOfHotelNights)}
            </p>
            <div>
              {hotels?.map((hotel) => (
                <CruisePackageInfoHotel
                  hotel={hotel}
                  key={hotel?.id}
                />
              ))}
            </div>
          </div>
        )}
      </div>
      <Message
        header={labels?.packageInfoMessageHeading}
        messageType="info"
        expandable
        initiallyExpanded
      >
        {labels?.packageInfoMessageBody}
      </Message>
    </div>
  );
};

CruisePackageInfo.propTypes = {
  accommodation: PropTypes.shape({
    hotels: PropTypes.arrayOf(PropTypes.shape()),
    numberOfHotelNights: PropTypes.number,
  }).isRequired,
  duration: PropTypes.string.isRequired,
  transport: PropTypes.shape({
    homeBoundFlights: PropTypes.arrayOf(PropTypes.shape({})),
    outBoundFlights: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  promoLabel: PropTypes.shape({
    text: PropTypes.string,
    urgency: PropTypes.string,
    promotionType: PropTypes.string,
  }),
};

export default CruisePackageInfo;
